export const IMAGENS_SATISFACAO = [
  "satisfacao_naoinformado.png",
  "satisfacao_excelente.png",
  "satisfacao_muitobom.png",
  "satisfacao_bom.png",
  "satisfacao_ruim.png",
  "satisfacao_muitoruim.png",
];

export const VALORES_SATISFACAO = [
  "Não Informado",
  "Excelente",
  "Muito Bom",
  "Bom",
  "Ruim",
  "Muito Ruim",
];

// Cores representativas para cada status de uma OS.
// [Aberta, NaoRealizada, Fechada, Cancelada, Executada, Reprovada:  ]
export const CORES_STATUS_OS: string[] = [
  "",
  "#5b9bd5",
  "#a94442",
  "#70ad47",
  "#ed7d31",
  "#A36EC0",
  "#a94442",
  "#393ed6",
  "#c510b9",
];

export const STATUS_OS: string[] = [
  "",
  "Aberta",
  "Nao Realizada",
  "Fechada",
  "Cancelada",
  "Executada",
  "Reprovada",
  "Visto Execução",
  "OS Validada"
  
];
